import { render, staticRenderFns } from "./SlotCounterTotal.vue?vue&type=template&id=ffa0f16e&"
import script from "./SlotCounterTotal.vue?vue&type=script&lang=js&"
export * from "./SlotCounterTotal.vue?vue&type=script&lang=js&"
import style0 from "./SlotCounterTotal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffa0f16e')) {
      api.createRecord('ffa0f16e', component.options)
    } else {
      api.reload('ffa0f16e', component.options)
    }
    module.hot.accept("./SlotCounterTotal.vue?vue&type=template&id=ffa0f16e&", function () {
      api.rerender('ffa0f16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Counter/SlotCounterTotal.vue"
export default component.exports